import { render, staticRenderFns } from "./ForeignStudentWarning.vue?vue&type=template&id=871b726c"
import script from "./ForeignStudentWarning.vue?vue&type=script&lang=js"
export * from "./ForeignStudentWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports